import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "./App.css";
import CustomCursor from "./components/CustomCursor";
import ThemeInjector from "./components/ThemeInjector";
import Home from "./pages/Home";
import ProjectDetail from "./pages/ProjectDetail";
import ServiceDetail from "./pages/ServiceDetail";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminShorts from "./pages/admin/AdminShorts";
import AdminServices from "./pages/admin/AdminServices";
import AdminProjects from "./pages/admin/AdminProjects";
import AdminBrands from "./pages/admin/AdminBrands";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminBts from "./pages/admin/AdminBts";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminSettings from "./pages/admin/AdminSettings";
import RequireAuth from "./pages/admin/RequireAuth";
import useSmoothScroll from "./lib/useSmoothScroll";
import useAnalytics from "./lib/useAnalytics";

function PageWrap({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.5, ease: [0.2, 0.9, 0.2, 1] }}
    >
      {children}
    </motion.div>
  );
}

function AppRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrap><Home /></PageWrap>} />
        <Route path="/projects/:slug" element={<PageWrap><ProjectDetail /></PageWrap>} />
        <Route path="/services/:slug" element={<PageWrap><ServiceDetail /></PageWrap>} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/*"
          element={
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          }
        >
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="shorts" element={<AdminShorts />} />
          <Route path="services" element={<AdminServices />} />
          <Route path="projects" element={<AdminProjects />} />
          <Route path="brands" element={<AdminBrands />} />
          <Route path="testimonials" element={<AdminTestimonials />} />
          <Route path="bts" element={<AdminBts />} />
          <Route path="messages" element={<AdminMessages />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
        <Route path="*" element={<PageWrap><NotFound /></PageWrap>} />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  useSmoothScroll();
  useAnalytics();
  return (
    <div className="App">
      <ThemeInjector />
      <CustomCursor />
      <AppRoutes />
    </div>
  );
}
